import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  Tab,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  Tabs,
  Typography,
  TableRow,
  TableBody,
} from "@mui/material";
import { styled, withStyles } from "@material-ui/core";
import dayjs from "dayjs";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import "../../CSS/app.min.css";
import "../../CSS/bootstrap.min.css";
import "../../CSS/custom.min.css";
import "../../CSS/mermaid.min.css";
import "../../CSS/slickDashboard.css";
import { onToggle } from "../../CommonActions/common.slice";
import image4 from "../../Images/image4.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import { getManagerDashboardApi } from "../../Slice/managerDashboard.slice";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import DonutChart from "../DashbourdChanges/DonutChart";
import MonthlyBarChart from "../DashbourdChanges/MonthlyBarChart";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import CategoryWiseSummaryPopUpRMDashboard from "./CategoryWiseSummaryPopUpRMDashboard";
import TargetPopUpRMDashboard from "./TargetPopUpRMDashboard";
import TimeSlotOtherTaskPopUpRMDashboard from "./TimeSlotOtherTaskPopUpRMDashboard";
import TimeSlotPopUpRMDashboard from "./TimeSlotPopUpRMDashboard";
import UserSummaryPopUpRMDashboard from "./UserSummaryPopUpRMDashboard";
import UserWorkSummaryPopUpRMDashboard from "./UserWorkSummaryPopUpRMDashboard";
import TeamCoverageSelfPopUp from "./TeamCoverageSelfPopUp";
import TeamCoverageForSalesTeamPopUp from "./TeamCoverageForSalesTeamPopUp";
import TeamCoverageForBeatPopUp from "./TeamCoverageForBeatPopUp";
import TeamCoverageForOutletPopUp from "./TeamCoverageForOutletPopUp";
import TeamCoverageForTimeLinePopUp from "./TeamCoverageForTimeLinePopUp";
import TeamCoverageForProductPopUp from "./TeamCoverageForProductPopUp";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { cyanBlue, redColor, titleColor } from "../../config/ColorObj";
import { downloadF } from "../PDF/PDFDownload";
import { getSalesTeamInfoByDatesWithAttendance } from "../../Slice/adminDashboard.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { getBeatFromSalesTeamId } from "../../Slice/beat.slice";
import BeatPopUp from "../DashbourdChanges/BeatPopUp";

const StickyTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fff",
    // color: theme.palette.common.white,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 2,
  },
  body: {
    backgroundColor: "#fff",
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
}))(TableCell);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class RMDashboard extends Component {
  toggleDrawer = () => {
    this.props.onToggle();
  };
  state = {
    showFeedback: false,
    showPreview: false,
    date1: new Date(),
    newDate: "",
    currentDate: new Date(),
    curDate: new Date(),
    dob: "",
    dobDay: "",
    dobMonth: "",
    currenDate: "",
    currentMonth: "",
    timeTableList: [],
    subject: "",
    batch: "",
    yearDetail: "",
    semester: "",
    division: "",
    pieChartData: [],
    isLoading: false,
    showLoader: false,
    profile: "",
    nameFirstLetter: "",
    showZone: false,
    showArea: false,
    date: "",
    saleDate: "",
    outletDate: "",
    monthDate: "",
    yearDate: "",
    type: "",
    saleMonth: dayjs(),
    selectedDate: dayjs(),
    dateForSalesTeamList: dayjs(),
    saleYear: "",
    month: "",
    year: "",
    productArea: "",
    productZone: "",
    outletArea: "",
    outletZone: "",
    formErrors: {},
    graphList: [],
    DataToSetForCat: [],
    targetAchievementList: [],
    userSummaryList: [],
    onClickTagetFlag: false,
    onClickUserSummaryFlag: false,
    onClickUserWorkSummaryFlag: false,
    byProductWiseCatSummary: [],
    onClickCatSummaryFlag: false,
    onClickTimeSlotTaskFlag: false,
    catWiseSummaryType: 0,
    packagingTypeList: [],
    categoryIdForSummary: "",
    grandTotalForProductWise: 0,
    grandTotalForPackagingTypeWise: 0,
    otherTaskId: 0,
    filterTimeSLotList: [],
    onClickTimeSlotFlag: false,
    otherTaskIdForTimeSlot: 0,
    timeSlotTaskList: [],
    taskName: "",
    loginPersonDataList: [],
    onClickTeamCoverageSelfFlag: false,
    teamCoverageSalesTeamList: [],
    onClickTeamCoverageSalesTeamFlag: false,
    onClickTeamCoverageBeatFlag: false,
    teamCoverageBeatList: [],
    onClickTeamCoverageOutletFlag: false,
    teamCoverageForOutletList: [],
    teamCoverageForTimline: [],
    onClickTeamCoverageTimelineFlag: false,
    onClickTeamCoverageProductFlag: false,
    teamCoverageForProduct: [],
    rowOuletId: "",
    rowsPerPage: 10,
    page: 0,
    searchValueForSalesTeamList: "",
    beatPopupFlag: false,
    value: "0",
    totalOutletCount: 0,
    productiveCall: 0,
    remoteOrder: 0,
    unvisited: 0,
    zero: 0,
    totalAmount: 0,
    salesAmt: 0,
    monthList: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    radioValue: [
      {
        name: "Target",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
      {
        name: "Achieved",
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      },
    ],
    columns: [
      { id: "name", label: "Name", minWidth: 170 },
      { id: "code", label: "ISO\u00a0Code", minWidth: 100 },
      {
        id: "population",
        label: "Population",
        minWidth: 170,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "size",
        label: "Size\u00a0(km\u00b2)",
        minWidth: 170,
        align: "right",
        format: (value) => value.toLocaleString("en-US"),
      },
      {
        id: "density",
        label: "Density",
        minWidth: 170,
        align: "right",
        format: (value) => value.toFixed(2),
      },
    ],
    rows: [
      this.createData("India", "IN", 1324171354, 3287263),
      this.createData("China", "CN", 1403500365, 9596961),
      this.createData("Italy", "IT", 60483973, 301340),
      this.createData("United States", "US", 327167434, 9833520),
      this.createData("Canada", "CA", 37602103, 9984670),
      this.createData("Australia", "AU", 25475400, 7692024),
      this.createData("Germany", "DE", 83019200, 357578),
      this.createData("Ireland", "IE", 4857000, 70273),
      this.createData("Mexico", "MX", 126577691, 1972570),
      this.createData("Japan", "JP", 126317000, 377973),
      this.createData("France", "FR", 67022000, 640679),
      this.createData("United Kingdom", "GB", 67545757, 242495),
      this.createData("Russia", "RU", 146793744, 17098246),
      this.createData("Nigeria", "NG", 200962417, 923768),
      this.createData("Brazil", "BR", 210147125, 8515767),
    ],
  };

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0,
    });
  };

  createData(name, code, population, size) {
    const density = population / size;
    return { name, code, population, size, density };
  }

  async componentDidMount() {
    const { showLoador, showNotification, getManagerDashboardApi } = this.props;
    const { selectedDate } = this.state;
    if (navigator.onLine) {
      let loginPersonDataList = [];
      let loginPersonName = "";
      let achievedAmount = "";
      let ruAchievedQty = "";
      let loginUserId = localStorage.getItem("userId")
        ? localStorage.getItem("userId")
        : "";

      if (localStorage.getItem("loginUserData")) {
        let loginUserDataObj = JSON.parse(
          localStorage.getItem("loginUserData")
        );

        loginPersonName =
          loginUserDataObj.name !== null &&
            loginUserDataObj.stockStakeHolderType !== null &&
            loginUserDataObj.stockStakeHolderType.prefix !== null
            ? loginUserDataObj.name +
            " (" +
            loginUserDataObj.stockStakeHolderType.prefix +
            ")"
            : "";
      }

      showLoador({ loador: true });
      await getManagerDashboardApi({ date: dayjs().format("DD-MM-YYYY") }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: myConstClass.serverMsg,
              severity: "error",
            });
          } else {
            if (response) {
              (ruAchievedQty =
                response?.dtoSalesPersonYearMonthTargetAndActualAmt
                  ?.ruAchievedQty),
                (achievedAmount = ConvertAmount({
                  amount:
                    response?.dtoSalesPersonYearMonthTargetAndActualAmt
                      ?.actualAmt,
                }));
            }
          }
        }
      );

      loginPersonDataList.push({
        index: 1,
        loginPersonId: loginUserId,
        loginPersonName: loginPersonName,
        achievedAmount: achievedAmount + " / " + ruAchievedQty,
      });

      this.setState({
        loginPersonDataList,
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  }

  columns = [
    {
      name: "index",
      title: "Sr.No",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "center",
    },
    {
      name: "name",
      title: "Name",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "left",
    },
    {
      name: "targetAmt",
      title: "Target Amount",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
    {
      name: "actualAmt",
      title: "Acheived",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
    {
      name: "contribution",
      title: "% Contribution",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
    {
      name: "divisional",
      title: "%(-/+)",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
  ];
  graphList = [{ x: 1, y: 64 }];

  onChangeRadioValue = (value) => {
    if (value == "0") {
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
          },
        ],
      });
    } else if (value == "1") {
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [50, 60, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
          },
        ],
      });
    } else if (value == "2") {
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [80, 70, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
          },
        ],
      });
    } else if (value == "3") {
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [10, 20, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
          },
        ],
      });
    }
  };

  targetCardMethod = () => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let targetAchievementList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.target +
        "/get-achieved-amt-by-date?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY"),
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          targetAchievementList = data.data.map((dataObj, index) => {
            const dayOfWeek = moment(dataObj.selectedDate, "DD-MM-YYYY").format(
              "dddd"
            );
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              selectedDate:
                dataObj.selectedDate !== null ? dataObj.selectedDate : "",
              day: dayOfWeek ? dayOfWeek : "",
              totalAchievedAmount:
                dataObj.totalAchievedAmount !== null
                  ? dataObj.totalAchievedAmount
                  : "",
              AchievedTarget:
                dataObj.totalAchievedAmount !== null &&
                  dataObj.totalRUWiseAchievedQty !== null
                  ? dataObj.totalAchievedAmount.toFixed(2) +
                  "/" +
                  dataObj.totalRUWiseAchievedQty.toFixed(2)
                  : "",
            };
          });
          this.setState({ targetAchievementList, onClickTagetFlag: true });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  userSummaryCardMethod = () => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let userSummaryList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.salesExecutive +
        "/get-sales-team-with-flag-check-in-out-status?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY"),
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          userSummaryList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              name:
                dataObj.name !== null && dataObj.stockHolderShortName !== null
                  ? dataObj.name + " (" + dataObj.stockHolderShortName + ")"
                  : "",
              address: dataObj.address !== null ? dataObj.address : "",
              flag:
                dataObj.flag !== null
                  ? dataObj.flag == 0
                    ? "Absent"
                    : dataObj.flag == 1
                      ? "Late"
                      : dataObj.flag == 2
                        ? "In Time"
                        : "On Leave"
                  : "",
              checkInTime:
                dataObj.checkInTime !== null ? dataObj.checkInTime : "",
              checkOutTime:
                dataObj.checkOutTime !== null ? dataObj.checkOutTime : "",
              otherTaskName:
                dataObj.otherTaskName !== null ? dataObj.otherTaskName : "-",
              workingHrs: dataObj.workingHrs !== null ? dataObj.workingHrs : "",
              userTypeId: dataObj.userTypeId !== null ? dataObj.userTypeId : "",
            };
          });

          this.setState({ userSummaryList, onClickUserSummaryFlag: true });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  onclickUserWorkSummary = (otherTaskId) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    this.setState({ otherTaskId });

    if (![5, 7, 8, 0].includes(otherTaskId)) {
      let flag = otherTaskId;
      let userWorkSummaryList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.managerLogs +
          "/get-sales-team-by-date-and-task-type-with-flag-value?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&flag=" +
          flag,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            userWorkSummaryList = data.data.map((dataObj, index) => {
              return {
                index: index + 1,
                id: dataObj.id !== null ? dataObj.id : "",
                userTypeId:
                  dataObj.stockStakeHolderType !== null &&
                    dataObj.stockStakeHolderType.userType !== null &&
                    dataObj.stockStakeHolderType.userType.id !== null
                    ? dataObj.stockStakeHolderType.userType.id
                    : "",
                name:
                  dataObj.name !== null &&
                    dataObj.stockStakeHolderType !== null &&
                    dataObj.stockStakeHolderType.prefix !== null
                    ? dataObj.name +
                    " (" +
                    dataObj.stockStakeHolderType.prefix +
                    ")"
                    : "",
                address: dataObj.address !== null ? dataObj.address : "",
                areaNames: dataObj.areaNames !== null ? dataObj.areaNames : "",
                checkInTime:
                  dataObj.checkInTime !== null ? dataObj.checkInTime : "",
                checkOutTime:
                  dataObj.checkOutTime !== null ? dataObj.checkOutTime : "",
                workingHrs:
                  dataObj.workingHrs !== null ? dataObj.workingHrs : "",
                flag:
                  dataObj.flag !== null
                    ? dataObj.flag == 0
                      ? "Absent"
                      : dataObj.flag == 1
                        ? "Late"
                        : "In Time"
                    : "",
                firstCall: dataObj.firstCall !== null ? dataObj.firstCall : "",
                firstPc: dataObj.firstPc !== null ? dataObj.firstPc : "",
                scCount: dataObj.scCount !== null ? dataObj.scCount : "-",
                tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
                pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
                zocCount: dataObj.zocCount !== null ? dataObj.zocCount : "",
                target: dataObj.target !== null ? dataObj.target : "",
                netAmt:
                  dataObj.netAmt !== null ? dataObj.netAmt.toFixed(2) : "",
                avgAmt:
                  dataObj.avgAmt !== null ? dataObj.avgAmt.toFixed(2) : "",
                qty: dataObj.qty !== null ? dataObj.qty : "",
                lpsiPer:
                  dataObj.lpsiPer !== null ? dataObj.lpsiPer.toFixed(2) : "",
                productivityPer:
                  dataObj.productivityPer !== null
                    ? dataObj.productivityPer.toFixed(2)
                    : "",
              };
            });

            this.setState({
              DataToSetUserWorkSummary: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Task Name",
                  value:
                    otherTaskId == 1
                      ? "Outlet"
                      : otherTaskId == 2
                        ? "Distributor"
                        : otherTaskId == 3
                          ? "Office Work"
                          : otherTaskId == 4
                            ? "Joint Work"
                            : otherTaskId == 6
                              ? "Other"
                              : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Selected Date",
                  value: dayjs(selectedDate).format("DD-MM-YYYY"),
                },
              ],
              userWorkSummaryList,
              onClickUserWorkSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { dateForSalesTeamList } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.adminDashboard +
          "/get-excel-sales-teams?fromDate=" +
          dayjs(dateForSalesTeamList).format("DD-MM-YYYY") +
          "&toDate=" +
          dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
        ext: "xlsx",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  handleChangeTabValue = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  onClickCatgoryWiseSummary = (categoryId) => {
    const { showLoador, showNotification } = this.props;
    const { catWiseSummaryType, selectedDate } = this.state;

    if (catWiseSummaryType == 0) {
      let byProductWiseCatSummary = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/product-wise-total-amt-by-category-and-date?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoGroupWiseTotalAmtAndQty.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForProductWise = ConvertAmount({
              amount: grandTotal,
            }),
              byProductWiseCatSummary =
                data.data.dtoGroupWiseTotalAmtAndQty.map((dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id,
                    productName: dataObj.name,
                    totalQty: dataObj.totalQty,
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                });

            this.setState({
              categoryIdForSummary: categoryId,
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                      data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForProductWise
                    ? grandTotalForProductWise
                    : "",
                },
              ],
              byProductWiseCatSummary,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  handleCloses = () => {
    this.setState({
      onClickTagetFlag: false,
      onClickUserSummaryFlag: false,
      onClickUserWorkSummaryFlag: false,
      onClickCatSummaryFlag: false,
      catWiseSummaryType: 0,
      onClickTimeSlotFlag: false,
    });
  };

  handleClosesForTimeSlot = () => {
    this.setState({
      onClickTimeSlotTaskFlag: false,
    });
  };

  handleCloseForTeamCoverage = () => {
    this.setState({
      onClickTeamCoverageSelfFlag: false,
    });
  };

  changeRadioHandler = (event) => {
    this.setState({
      catWiseSummaryType: event.target.value,
    });

    const { showLoador, showNotification } = this.props;
    const { categoryIdForSummary, selectedDate } = this.state;

    if (event.target.value == 0) {
      let byProductWiseCatSummary = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/product-wise-total-amt-by-category-and-date?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryIdForSummary,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoGroupWiseTotalAmtAndQty.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForProductWise = ConvertAmount({
              amount: grandTotal,
            }),
              byProductWiseCatSummary =
                data.data.dtoGroupWiseTotalAmtAndQty.map((dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id,
                    productName: dataObj.name,
                    totalQty: dataObj.totalQty,
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                });

            this.setState({
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                      data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForProductWise
                    ? grandTotalForProductWise
                    : "",
                },
              ],
              byProductWiseCatSummary,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    } else {
      let packagingTypeList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/packing-type-wise-total-amt-by-category-and-date?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryIdForSummary,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoPackagingTypeWiseTotalList.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForPackagingTypeWise = ConvertAmount({
              amount: grandTotal,
            }),
              packagingTypeList = data.data.dtoPackagingTypeWiseTotalList.map(
                (dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id !== null ? dataObj.id : "",
                    packagingTypeName:
                      dataObj.packagingType !== null
                        ? dataObj.packagingType.name
                        : "",
                    totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                }
              );

            this.setState({
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                      data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForPackagingTypeWise
                    ? grandTotalForPackagingTypeWise
                    : "",
                },
              ],
              packagingTypeList,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  rowLink = (rowData) => {
    this.props.navigate("/sales/" + rowData.id + "/" + rowData.userTypeId);
  };

  rowLinkForTeamCoverage = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let teamCoverageFirstList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-sales-team-and-counts-new?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY") +
        "&flag=1&salesTeamId=",
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageFirstList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              salesTeamId:
                dataObj.salesTeam !== null ? dataObj.salesTeam.id : "",
              salesTeamName:
                dataObj.salesTeam !== null &&
                  dataObj.salesTeam.stockStakeHolderType !== null
                  ? dataObj.salesTeam.name +
                  " (" +
                  dataObj.salesTeam.stockStakeHolderType.prefix +
                  ")"
                  : "",
              salesTeamUserTypeId:
                dataObj.salesTeam !== null &&
                  dataObj.salesTeam.stockStakeHolderType !== null &&
                  dataObj.salesTeam.stockStakeHolderType.userType !== null
                  ? dataObj.salesTeam.stockStakeHolderType.userType.id
                  : "",
              address:
                dataObj.salesTeam !== null ? dataObj.salesTeam.address : "",
              distributorsCount:
                dataObj.distributorsCount !== null
                  ? dataObj.distributorsCount
                  : "",
              beatCount: dataObj.beatCount !== null ? dataObj.beatCount : "",
              outletCount:
                dataObj.outletCount !== null ? dataObj.outletCount : "",
              totalAmt:
                dataObj.totalAmt !== null
                  ? ConvertAmount({ amount: dataObj.totalAmt })
                  : "",
              tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
              unvisited:
                dataObj.outletCount !== null &&
                  dataObj.visitedOutletCount !== null
                  ? dataObj.outletCount - dataObj.visitedOutletCount
                  : "",
              pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
              visitedOutletCount:
                dataObj.visitedOutletCount !== null
                  ? dataObj.visitedOutletCount
                  : "",
            };
          });

          this.setState({
            teamCoverageFirstList,
            onClickTeamCoverageSelfFlag: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkTeamCoverageForSalesTeam = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let teamCoverageSalesTeamList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-sales-team-and-counts-new?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY") +
        "&flag=1&salesTeamId=" +
        rowData.salesTeamId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageSalesTeamList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              salesTeamId:
                dataObj.salesTeam !== null ? dataObj.salesTeam.id : "",
              salesTeamName:
                dataObj.salesTeam !== null &&
                  dataObj.salesTeam.stockStakeHolderType !== null
                  ? dataObj.salesTeam.name +
                  " (" +
                  dataObj.salesTeam.stockStakeHolderType.prefix +
                  ")"
                  : "",
              salesTeamUserTypeId:
                dataObj.salesTeam !== null &&
                  dataObj.salesTeam.stockStakeHolderType !== null &&
                  dataObj.salesTeam.stockStakeHolderType.userType !== null
                  ? dataObj.salesTeam.stockStakeHolderType.userType.id
                  : "",
              address:
                dataObj.salesTeam !== null ? dataObj.salesTeam.address : "",
              distributorsCount:
                dataObj.distributorsCount !== null
                  ? dataObj.distributorsCount
                  : "",
              beatCount: dataObj.beatCount !== null ? dataObj.beatCount : "",
              outletCount:
                dataObj.outletCount !== null ? dataObj.outletCount : "",
              totalAmt:
                dataObj.totalAmt !== null
                  ? ConvertAmount({ amount: dataObj.totalAmt })
                  : "",
              tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
              unvisited:
                dataObj.outletCount !== null &&
                  dataObj.visitedOutletCount !== null
                  ? dataObj.outletCount - dataObj.visitedOutletCount
                  : "",
              pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
              visitedOutletCount:
                dataObj.visitedOutletCount !== null
                  ? dataObj.visitedOutletCount
                  : "",
            };
          });

          this.setState({
            teamCoverageSalesTeamList,
            onClickTeamCoverageSalesTeamFlag: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkTeamCoverageForSalesTeamOrBeat = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    if (rowData.salesTeamUserTypeId == 3) {
      let teamCoverageSalesTeamList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.managerLogs +
          "/get-sales-team-and-counts-new?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&flag=1&salesTeamId=" +
          rowData.salesTeamId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            teamCoverageSalesTeamList = data.data.map((dataObj, index) => {
              return {
                index: index + 1,
                salesTeamId:
                  dataObj.salesTeam !== null ? dataObj.salesTeam.id : "",
                salesTeamName:
                  dataObj.salesTeam !== null &&
                    dataObj.salesTeam.stockStakeHolderType !== null
                    ? dataObj.salesTeam.name +
                    " (" +
                    dataObj.salesTeam.stockStakeHolderType.prefix +
                    ")"
                    : "",
                salesTeamUserTypeId:
                  dataObj.salesTeam !== null &&
                    dataObj.salesTeam.stockStakeHolderType !== null &&
                    dataObj.salesTeam.stockStakeHolderType.userType !== null
                    ? dataObj.salesTeam.stockStakeHolderType.userType.id
                    : "",
                address:
                  dataObj.salesTeam !== null ? dataObj.salesTeam.address : "",
                distributorsCount:
                  dataObj.distributorsCount !== null
                    ? dataObj.distributorsCount
                    : "",
                beatCount: dataObj.beatCount !== null ? dataObj.beatCount : "",
                outletCount:
                  dataObj.outletCount !== null ? dataObj.outletCount : "",
                totalAmt:
                  dataObj.totalAmt !== null
                    ? ConvertAmount({ amount: dataObj.totalAmt })
                    : "",
                tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
                unvisited:
                  dataObj.outletCount !== null &&
                    dataObj.visitedOutletCount !== null
                    ? dataObj.outletCount - dataObj.visitedOutletCount
                    : "",
                pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
                visitedOutletCount:
                  dataObj.visitedOutletCount !== null
                    ? dataObj.visitedOutletCount
                    : "",
              };
            });

            this.setState({
              teamCoverageSalesTeamList,
              onClickTeamCoverageSalesTeamFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    } else {
      let teamCoverageBeatList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.beat +
          "/get-beat-by-sales-team?date=" +
          dayjs(selectedDate).format("DD-MM-YYYY") +
          "&salesTeamId=" +
          rowData.salesTeamId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            teamCoverageBeatList = data.data.map((dataObj, index) => {
              return {
                index: index + 1,
                beatId: dataObj.beatId !== null ? dataObj.beatId : "",
                beatName: dataObj.beatName !== null ? dataObj.beatName : "",
                outletCount:
                  dataObj.outletCount !== null ? dataObj.outletCount : "",
                unvisited:
                  dataObj.outletCount !== null &&
                    dataObj.distinctVisitedOutletCount !== null
                    ? dataObj.outletCount - dataObj.distinctVisitedOutletCount
                    : "",
                productiveCount:
                  dataObj.productiveCount !== null
                    ? dataObj.productiveCount
                    : "",
                totalAmt:
                  dataObj.totalAmt !== null
                    ? ConvertAmount({ amount: dataObj.totalAmt })
                    : "",
                totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
                newAddedOutletCount:
                  dataObj.newAddedOutletCount !== null
                    ? dataObj.newAddedOutletCount
                    : "",
              };
            });

            this.setState({
              teamCoverageBeatList,
              onClickTeamCoverageBeatFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  rowLinkTeamCoverageForOutlet = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let teamCoverageForOutletList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.outlet +
        "/get-outlet-by-beat-with-counts?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY") +
        "&beatId=" +
        rowData.beatId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageForOutletList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              outletId: dataObj.outletId !== null ? dataObj.outletId : "",
              firmName: dataObj.firmName !== null ? dataObj.firmName : "",
              lastVisitTime:
                dataObj.lastVisitTime !== null ? dataObj.lastVisitTime : "-",
              lastOrderTime:
                dataObj.lastOrderTime !== null ? dataObj.lastOrderTime : "-",
              totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
              totalAmt:
                dataObj.totalAmt !== null
                  ? ConvertAmount({ amount: dataObj.totalAmt })
                  : "",
              visitCount: dataObj.visitCount !== null ? dataObj.visitCount : "",
              productiveCount:
                dataObj.productiveCount !== null ? dataObj.productiveCount : "",
            };
          });

          this.setState({
            teamCoverageForOutletList,
            onClickTeamCoverageOutletFlag: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkTeamCoverageForTimeLine = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    this.setState({ rowOuletId: rowData.outletId });

    let teamCoverageForTimline = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.outletOrderHeader +
        "/total-amt-and-qty-by-outlet-till-date?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY") +
        "&outletId=" +
        rowData.outletId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageForTimline = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              salesId: dataObj.salesId !== null ? dataObj.salesId : "",
              date: dataObj.date !== null ? dataObj.date : "",
              salesPersonName:
                dataObj.salesPersonName !== null ? dataObj.salesPersonName : "",
              totalAmt: dataObj.totalAmt !== null ? dataObj.totalAmt : "",
              totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
            };
          });

          this.setState({
            teamCoverageForTimline,
            onClickTeamCoverageTimelineFlag: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkTeamCoverageForProduct = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate, rowOuletId } = this.state;

    let teamCoverageForProduct = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.outletOrderDetail +
        "/by-sales-team-outlet-and-date?salesTeamId=" +
        rowData.salesId +
        "&outletId=" +
        rowOuletId +
        "&date=" +
        dayjs(selectedDate).format("DD-MM-YYYY"),
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageForProduct = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              groupId: dataObj.groupId !== null ? dataObj.groupId : "",
              packagingTypeId:
                dataObj.packagingTypeId !== null ? dataObj.packagingTypeId : "",
              tagIds: dataObj.tagIds !== null ? dataObj.tagIds : "",
              taxPercentageId:
                dataObj.taxPercentageId !== null ? dataObj.taxPercentageId : "",
              stakeHolderUomId:
                dataObj.stakeHolderUomId !== null
                  ? dataObj.stakeHolderUomId
                  : "",
              outletUomId:
                dataObj.outletUomId !== null ? dataObj.outletUomId : "",
              uomConversionValue:
                dataObj.uomConversionValue !== null
                  ? dataObj.uomConversionValue
                  : "",
              code: dataObj.code !== null ? dataObj.code : "",
              productCode:
                dataObj.productCode !== null ? dataObj.productCode : "",
              name: dataObj.name !== null ? dataObj.name : "",
              shortName: dataObj.shortName !== null ? dataObj.shortName : "",
              weight: dataObj.weight !== null ? dataObj.weight : "",
              image: dataObj.image !== null ? dataObj.image : "",
              sortOrder: dataObj.sortOrder !== null ? dataObj.sortOrder : "",
              isActive: dataObj.isActive !== null ? dataObj.isActive : "",
              totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
            };
          });

          this.setState({
            teamCoverageForProduct,
            onClickTeamCoverageProductFlag: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  timeSlotsMethod = (id) => {
    const { showLoador, showNotification, managerDashboardData } = this.props;

    const filterTimeSLotList = managerDashboardData.dashboardApi.timeSlots
      .filter((row) => row.id === id)
      .map((dataObj, index) => {
        return {
          index: index + 1,
          id: dataObj.id !== null ? dataObj.id : "",
          fromTime: dataObj.fromTime !== null ? dataObj.fromTime : "",
          toTime: dataObj.toTime !== null ? dataObj.toTime : "",
          isActive: dataObj.isActive !== null ? dataObj.isActive : "",
          dtoTimeSlotAndOtherTasks:
            dataObj.dtoTimeSlotAndOtherTasks !== null
              ? dataObj.dtoTimeSlotAndOtherTasks.map((taskObj, index) => {
                return {
                  index: index + 1,
                  uuid: taskObj.uuid !== null ? taskObj.uuid : "",
                  otherTaskId:
                    taskObj.otherTaskId !== null ? taskObj.otherTaskId : "",
                  otherTaskName:
                    taskObj.otherTaskName !== null
                      ? taskObj.otherTaskName
                      : "",
                  count: taskObj.count !== null ? taskObj.count : "",
                  timeSlotId:
                    taskObj.timeSlotId !== null ? taskObj.timeSlotId : "",
                };
              })
              : [],
        };
      });

    this.setState({
      filterTimeSLotList,
      onClickTimeSlotFlag: true,
    });
  };

  rowLinkForTimeSlot = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let timeSlotTaskList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-by-time-slot?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY") +
        "&flag=" +
        rowData.otherTaskId +
        "&timeSlotId=" +
        rowData.timeSlotId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          timeSlotTaskList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              date: dataObj.date !== null ? dataObj.date : "",
              salesTeamPersonName:
                dataObj.salesTeamPersonName !== null &&
                  dataObj.stockStakeHolderTypePrefix !== null
                  ? dataObj.salesTeamPersonName +
                  " (" +
                  dataObj.stockStakeHolderTypePrefix +
                  ")"
                  : "",
              salesTeamPersonAddress:
                dataObj.salesTeamPersonAddress !== null
                  ? dataObj.salesTeamPersonAddress
                  : "",
              fromTime: dataObj.fromTime !== null ? dataObj.fromTime : "",
              entityName: dataObj.entityName !== null ? dataObj.entityName : "",
              description:
                dataObj.description !== null ? dataObj.description : "",
              amount: dataObj.description !== null ? dataObj.description : "",
              extra1: dataObj.extra1 !== null ? dataObj.extra1 : "",
              checkInOut: dataObj.checkInOut !== null ? dataObj.checkInOut : "",
              otherTaskId:
                dataObj.otherTask !== null ? dataObj.otherTask.id : "",
              otherTaskName:
                dataObj.otherTask !== null ? dataObj.otherTask.name : "",
              outletId: dataObj.outletId !== null ? dataObj.outletId : "",
              remarkName: dataObj.remarkName !== null ? dataObj.remarkName : "",
              salesTeamPersonId:
                dataObj.salesTeamPersonId !== null
                  ? dataObj.salesTeamPersonId
                  : "",
              stockStakeHolderId:
                dataObj.stockStakeHolderId !== null
                  ? dataObj.stockStakeHolderId
                  : "",
              stockStakeHolderTypeId:
                dataObj.stockStakeHolderTypeId !== null
                  ? dataObj.stockStakeHolderTypeId
                  : "",
              stockStakeHolderTypeName:
                dataObj.stockStakeHolderTypeName !== null
                  ? dataObj.stockStakeHolderTypeName
                  : "",
              timeDifference:
                dataObj.timeDifference !== null ? dataObj.timeDifference : "",
              toTime: dataObj.toTime !== null ? dataObj.toTime : "",
              workingTypeId:
                dataObj.workingType !== null ? dataObj.workingType.id : "",
              workingTypeName:
                dataObj.workingType !== null ? dataObj.workingType.name : "",
              workingTypeOtherTask:
                dataObj.workingType !== null
                  ? dataObj.workingType.otherTask
                  : "",
            };
          });

          this.setState({
            taskName: rowData.otherTaskName,
            timeSlotTaskList,
            onClickTimeSlotTaskFlag: true,
            otherTaskIdForTimeSlot: rowData.otherTaskId,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  changeDateNew = (name) => (date) => {
    if (name === "dateForSalesTeamList") {
      this.setState({
        dateForSalesTeamList: date,
      });
    }
  };

  searchSalesTeamData = () => {
    const {
      getSalesTeamInfoByDatesWithAttendance,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { dateForSalesTeamList } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSalesTeamInfoByDatesWithAttendance({
        fromDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
        toDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: response.serverMsg, severity: "error" });
        } else {
          let totalOutletCount = 0,
            zero = 0,
            productiveCall = 0,
            unvisited = 0,
            salesAmt = 0,
            totalAmount = 0,
            remoteOrder = 0;
          if (response.length !== 0) {
            response.map((salesTeam) => {
              totalOutletCount = totalOutletCount + +salesTeam.totalOutletCount;
              productiveCall = productiveCall + +salesTeam.productiveCall;
              zero = zero + +salesTeam.zeroOrderCount;
              unvisited = unvisited + +salesTeam.unvisitedOutletCount;
              salesAmt = salesAmt + +salesTeam.totalSalesAmt;
              totalAmount = totalAmount + +salesTeam.totalAmount;
              remoteOrder = remoteOrder + +salesTeam.remoteOrderCount;
            });
          }
          this.setState({
            totalOutletCount: totalOutletCount,
            zero: zero,
            productiveCall: productiveCall,
            unvisited: unvisited,
            salesAmt: salesAmt,
            totalAmount: totalAmount,
            remoteOrder: remoteOrder,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  salesTeamHandler = (e, salesTeamId) => {
    const { getBeatFromSalesTeamId, showLoador, showNotification } = this.props;
    const { popUpFlag } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getBeatFromSalesTeamId({
        salesTeamIds: salesTeamId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            beatPopupFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  handleClosesSalesTeam = () => {
    this.setState({
      beatPopupFlag: false,
    });
  };

  changeDate = (date) => {
    const { showLoador, showNotification, getManagerDashboardApi } = this.props;
    if (navigator.onLine) {
      this.setState({ selectedDate: date });

      showLoador({ loador: true });
      getManagerDashboardApi({ date: dayjs(date).format("DD-MM-YYYY") }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: myConstClass.serverMsg,
              severity: "error",
            });
          } else {
          }
        }
      );
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  handleCloseForTeamCoverageSalesTeam = () => {
    this.setState({ onClickTeamCoverageSalesTeamFlag: false });
  };

  handleCloseForTeamCoverageBeat = () => {
    this.setState({ onClickTeamCoverageBeatFlag: false });
  };

  handleCloseForTeamCoverageOutlet = () => {
    this.setState({ onClickTeamCoverageOutletFlag: false });
  };

  handleCloseForTeamCoverageTimeline = () => {
    this.setState({ onClickTeamCoverageTimelineFlag: false });
  };

  handleCloseForTeamCoverageProduct = () => {
    this.setState({ onClickTeamCoverageProductFlag: false });
  };

  onSearchForSalesTeamList = (searchValueForSalesTeamList) => {
    this.setState({
      searchValueForSalesTeamList: searchValueForSalesTeamList,
    });
  };

  getFilteredTableDataForSalesTeamList = (searchData) => {
    const { searchValueForSalesTeamList } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["district_names"] &&
          currentRow["district_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["area_names"] &&
          currentRow["area_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  render() {
    const {
      managerDashboardData,
      stockStakeHolderTypeList,
      zoneList,
      areaList,
      distributorDashbourd,
      dashboardData2,
      beatList,
    } = this.props;
    const {
      type,
      showZone,
      showArea,
      saleMonth,
      monthList,
      columns,
      rows,
      rowsPerPage,
      page,
      radioValue,
      productArea,
      productZone,
      outletArea,
      outletZone,
      onClickTagetFlag,
      targetAchievementList,
      userSummaryList,
      onClickUserSummaryFlag,
      userWorkSummaryList,
      onClickUserWorkSummaryFlag,
      onClickCatSummaryFlag,
      byProductWiseCatSummary,
      DataToSetForCat,
      catWiseSummaryType,
      packagingTypeList,
      grandTotalForPackagingTypeWise,
      grandTotalForProductWise,
      DataToSetUserWorkSummary,
      otherTaskId,
      filterTimeSLotList,
      onClickTimeSlotFlag,
      otherTaskIdForTimeSlot,
      onClickTimeSlotTaskFlag,
      timeSlotTaskList,
      taskName,
      selectedDate,
      loginPersonDataList,
      teamCoverageFirstList,
      onClickTeamCoverageSelfFlag,
      onClickTeamCoverageSalesTeamFlag,
      teamCoverageSalesTeamList,
      onClickTeamCoverageBeatFlag,
      teamCoverageBeatList,
      onClickTeamCoverageOutletFlag,
      teamCoverageForOutletList,
      teamCoverageForTimline,
      onClickTeamCoverageTimelineFlag,
      teamCoverageForProduct,
      onClickTeamCoverageProductFlag,
      dateForSalesTeamList,
      formErrors,
      totalOutletCount,
      productiveCall,
      remoteOrder,
      unvisited,
      zero,
      totalAmount,
      salesAmt,
      value,
      beatPopupFlag,
    } = this.state;
    const { typeError, dateError } = this.state.formErrors;

    return (
      <>
        <div
          id="layout-wrapper"
          style={{
            backgroundColor: "#fff",
          }}
        >
          {/* ========== App Menu ========== */}

          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here 
              {/* ============================================================== */}
          <div className="main-content">
            <div className="page-content">
              <Grid
                container
                xs={12}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item marginRight={-3}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    sx={{
                      minWidth: "300px",
                      flexWrap: "nowrap",
                    }}
                  >
                    <LabelCompo
                      className="text-black"
                      style={{
                        fontSize: 17,
                        marginRight: "8px",
                        marginBottom: "15px",
                        whiteSpace: "nowrap",
                      }}
                      label="Date :"
                    />
                    <Box sx={{ width: "180px" }}>
                      <BasicDatePicker
                        color="primary"
                        name="selectedDate"
                        size="small"
                        value={selectedDate}
                        disabled={false}
                        fullWidth
                        onChange={this.changeDate}
                        maxDate={dayjs()}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <div className="container-fluid">
                <div
                  className="row"
                  style={{
                    marginBottom: -17,
                    gap: 7,
                    display: "flex",
                    flexWrap: "nowrap",
                    width: "100%",
                    height: "auto",
                    padding: 5,
                    marginTop: -15,
                  }}
                >
                  {/* Card 1 */}
                  <div
                    className="Frame1000002996"
                    style={{
                      flex: "2",
                      height: "auto",
                      padding: 12,
                      background: "#EEF6FF",
                      borderRadius: 8,
                      justifyContent: "space-between",
                      alignItems: "center",
                      display: "inline-flex",
                      flexDirection: "column",
                    }}
                    onClick={this.targetCardMethod}
                  >
                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        display: "inline-flex",
                      }}
                    >
                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                        }}
                      >
                        Target
                      </div>

                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                          backgroundColor: "#F6FCFF",
                          borderRadius: "15%",
                          padding: "2px 6px",
                          fontWeight: "450",
                        }}
                      >
                        MTD
                      </div>
                    </div>

                    <div
                      className="Frame1000002994"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <div
                          style={{
                            color: "#43C622",
                            fontSize: 16,
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            textTransform: "capitalize",
                            overflowWrap: "break-word",
                          }}
                        >
                          {"₹ "}
                          {ConvertAmount({
                            amount:
                              Object.keys(managerDashboardData).length !== 0 &&
                                managerDashboardData.dashboardApi &&
                                managerDashboardData.dashboardApi
                                  .dtoSalesPersonYearMonthTargetAndActualAmt
                                ? managerDashboardData.dashboardApi
                                  .dtoSalesPersonYearMonthTargetAndActualAmt
                                  .mtdAchievedAmt
                                : 0,
                          })}
                        </div>

                        <div
                          style={{
                            color: "#43C622",
                            fontSize: 16,
                            fontFamily: "Poppins",
                            fontWeight: "300",
                            textTransform: "capitalize",
                            overflowWrap: "break-word",
                          }}
                        >
                          {Object.keys(managerDashboardData).length !== 0 &&
                            managerDashboardData.dashboardApi &&
                            managerDashboardData.dashboardApi
                              .dtoSalesPersonYearMonthTargetAndActualAmt
                            ? (() => {
                              const value =
                                managerDashboardData.dashboardApi
                                  .dtoSalesPersonYearMonthTargetAndActualAmt
                                  .mtdAchievedAmt;
                              const total =
                                managerDashboardData.dashboardApi
                                  .dtoSalesPersonYearMonthTargetAndActualAmt
                                  .monthTragetAmt;

                              if (value === 0 && total === 0) {
                                return "(0%)";
                              } else if (total === 0) {
                                return "(100%)";
                              } else {
                                const percentage = (value / total) * 100;
                                return `(${percentage.toFixed(0)}%)`;
                              }
                            })()
                            : "(0%)"}
                        </div>
                      </div>

                      <div
                        style={{
                          color: "#ff0000",
                          fontSize: 16,
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          textTransform: "capitalize",
                          wordWrap: "break-word",
                        }}
                      >
                        {"₹ "}
                        {ConvertAmount({
                          amount:
                            Object.keys(managerDashboardData).length !== 0 &&
                            managerDashboardData.dashboardApi &&
                            managerDashboardData.dashboardApi
                              .dtoSalesPersonYearMonthTargetAndActualAmt &&
                            managerDashboardData.dashboardApi.dtoSalesPersonYearMonthTargetAndActualAmt.monthTragetAmt.toFixed(
                              2
                            ),
                        })}
                      </div>
                    </div>
                  </div>

                  {/* Card 1  end*/}

                  {/* Card 2 */}

                  <div
                    className="Frame1000002996"
                    style={{
                      flex: "1.5",
                      height: "auto",
                      padding: 12,
                      background: "#FFFDE7",
                      borderRadius: 8,
                      justifyContent: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      maxWidth: "160px",
                    }}
                  >
                    <div
                      className="Frame11262"
                      style={{
                        padding: 12,

                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        display: "inline-flex",
                      }}
                    >
                      <div
                        className="Frame427319153"
                        style={{
                          width: "100%",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 8,
                          display: "inline-flex",
                        }}
                      >
                        <img
                          className="Image4"
                          style={{ width: 50, height: 50 }}
                          src={image4}
                        />
                        <div
                          className="TotalSales"
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            marginTop: 10,
                          }}
                        >
                          {"₹ "}
                          {ConvertAmount({
                            amount:
                              Object.keys(managerDashboardData).length !== 0 &&
                              managerDashboardData.dashboardApi &&
                              managerDashboardData.dashboardApi
                                .dtoSalesPersonYearMonthTargetAndActualAmt &&
                              managerDashboardData.dashboardApi
                                .dtoSalesPersonYearMonthTargetAndActualAmt
                                .ruAchieveAmt,
                          })}
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>

                  {/* Card 2 end */}

                  {/* Card 3 */}

                  <div
                    className="Frame427319167"
                    style={{
                      flex: "3.5",
                      height: "auto",
                      padding: 12,
                      background: "#E2FBFC",
                      borderRadius: 8,
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      display: "flex",
                      gap: "5px",
                      flexDirection: "column",
                      maxWidth: "320px",
                    }}
                    onClick={this.userSummaryCardMethod}
                  >
                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        // gap: 10,
                        display: "inline-flex",
                      }}
                    >
                      <div
                        className="Frame427319174"
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          // alignItems: "left",
                          fontSize: 14,
                          display: "flex",
                        }}
                      >
                        User Summary
                      </div>

                      <div
                        className="Frame427319174"
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          // alignItems: "left",
                          fontSize: 14,
                          display: "flex",
                          backgroundColor: "#F6FCFF",
                          borderRadius: "15%",
                          padding: "2px 6px",
                          fontWeight: "450",
                        }}
                      >
                        {dayjs(selectedDate).format("DD-MM-YYYY") ==
                          dayjs().format("DD-MM-YYYY")
                          ? "Todays"
                          : dayjs(selectedDate).format("DD-MM-YYYY")}
                      </div>
                    </div>

                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10,
                        display: "flex",
                      }}
                    >
                      <div
                        className="Frame427319166"
                        style={{
                          width: "100%",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "left",
                          display: "inline-flex",
                        }}
                      >
                        <div
                          className="Frame427319174"
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            display: "flex",
                            width: "535px",
                          }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "flex-end",
                              display: "flex",
                              width: "55%",
                            }}
                          >
                            <div
                              className="Frame427319174"
                              style={{
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                                display: "flex",
                                gap: "4px",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#000000",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .userSummary &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.totalSalesTeamCount &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.totalSalesTeamCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  Total
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#FFA500",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .userSummary &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInLateSalesTeamCount &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInLateSalesTeamCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  Late
                                </div>
                              </div>
                            </div>

                            <div
                              className="Frame427319174"
                              style={{
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                                display: "flex",
                                gap: "4px",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#43C622",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .userSummary &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInSalesTeamCount &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInSalesTeamCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  Check In
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#43C622",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .userSummary &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInTimeSalesTeamCount &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.checkInTimeSalesTeamCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  In-Time
                                </div>
                              </div>
                            </div>

                            <div
                              className="Frame427319174"
                              style={{
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                                display: "flex",
                                gap: "4px",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#FF0000",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData?.dashboardApi &&
                                    managerDashboardData?.dashboardApi
                                      ?.userSummary &&
                                    managerDashboardData?.dashboardApi
                                      ?.userSummary?.totalSalesTeamCount -
                                    managerDashboardData?.dashboardApi
                                      ?.userSummary?.checkInSalesTeamCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  Absent
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 16,
                                    color: "#43C622",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .userSummary &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.leaveApprovalPendingCount &&
                                    managerDashboardData.dashboardApi
                                      .userSummary.leaveApprovalPendingCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  On-Leave
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 end */}

                  {/* Card 4 starts */}
                  <div
                    className="Frame427319167"
                    style={{
                      flex: "2",
                      height: "auto",
                      padding: 12,
                      background: "rgba(253, 126, 20, 0.10)",
                      borderRadius: 8,
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: "8px",
                      display: "flex",

                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        display: "inline-flex",
                      }}
                    >
                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                        }}
                      >
                        Poductivity
                      </div>

                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                          backgroundColor: "#F6FCFF",
                          borderRadius: "15%",
                          padding: "2px 6px",
                          fontWeight: "450",
                        }}
                      >
                        MTD
                      </div>
                    </div>

                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10,
                        display: "flex",
                      }}
                    >
                      <div
                        className="Frame427319166"
                        style={{
                          width: "100%",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "left",
                          gap: 3,
                          display: "inline-flex",
                        }}
                      >
                        <div
                          className="Frame427319174"
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              flexDirection: "column",
                              width: "100%",
                              justifyContent: "space-between",
                              alignItems: "center",
                              display: "flex",
                              gap: "16px",
                            }}
                          >
                            <div
                              className="Frame427319166"
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                // gap: 10,
                                display: "flex",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignCoverageOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignCoverageOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  SC
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .mtdCallMade &&
                                    managerDashboardData.dashboardApi
                                      .mtdCallMade}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  CM
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .mtdCallProductive &&
                                    managerDashboardData.dashboardApi
                                      .mtdCallProductive}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  CP
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .mtdProductivity &&
                                    managerDashboardData.dashboardApi.mtdProductivity.toFixed(
                                      2
                                    )}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  P(%)
                                </div>
                              </div>
                            </div>

                            <div
                              className="Frame427319166"
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                display: "flex",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignCoverageOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignCoverageOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  COV
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignProsPectiveOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignProsPectiveOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  FOL
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignInActiveOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .beatAssignInActiveOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  IO
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Card 4 ends */}

                  {/* Card 5 Starts */}
                  <div
                    className="Frame427319167"
                    style={{
                      flex: "2",
                      height: "auto",
                      padding: 12,
                      background: "#ECFAF2",
                      borderRadius: 8,
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: "8px",
                      display: "flex",

                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        display: "inline-flex",
                      }}
                    >
                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                        }}
                      >
                        Poductivity
                      </div>

                      <div
                        className="Frame427319174"
                        style={{
                          fontSize: 14,
                          backgroundColor: "#F6FCFF",
                          borderRadius: "15%",
                          padding: "2px 6px",
                          fontWeight: "450",
                        }}
                      >
                        {dayjs(selectedDate).format("DD-MM-YYYY") ==
                          dayjs().format("DD-MM-YYYY")
                          ? "Todays"
                          : dayjs(selectedDate).format("DD-MM-YYYY")}
                      </div>
                    </div>

                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10,
                        display: "flex",
                      }}
                    >
                      <div
                        className="Frame427319166"
                        style={{
                          width: "100%",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "left",
                          gap: 3,
                          display: "inline-flex",
                        }}
                      >
                        <div
                          className="Frame427319174"
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              flexDirection: "column",
                              width: "100%",
                              justifyContent: "space-between",
                              alignItems: "center",
                              display: "flex",
                              gap: "16px",
                            }}
                          >
                            <div
                              className="Frame427319166"
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                // gap: 10,
                                display: "flex",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatCoverageOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatCoverageOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  SC
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayCallMade &&
                                    managerDashboardData.dashboardApi
                                      .todayCallMade}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  CM
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayCallProductive &&
                                    managerDashboardData.dashboardApi
                                      .todayCallProductive}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  CP
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayProductivity &&
                                    managerDashboardData.dashboardApi.todayProductivity.toFixed(
                                      2
                                    )}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                  }}
                                >
                                  P(%)
                                </div>
                              </div>
                            </div>

                            <div
                              className="Frame427319166"
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                display: "flex",
                              }}
                            >
                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatCoverageOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatCoverageOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  COV
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatProsPectiveOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatProsPectiveOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  FOL
                                </div>
                              </div>

                              <div
                                className="Frame427319174"
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {Object.keys(managerDashboardData).length !==
                                    0 &&
                                    managerDashboardData.dashboardApi &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatnInActiveOutletCount &&
                                    managerDashboardData.dashboardApi
                                      .todayBeatnInActiveOutletCount}
                                </div>
                                <div
                                  className="PendingForCheckIn"
                                  style={{
                                    color: "black",
                                    fontSize: 14,
                                    fontFamily: "Poppins",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  IO
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 5 ends */}
                </div>
                <br />
                {/* Sales & Manpower Div starts */}

                <div
                  className="row"
                  style={{
                    gap: 13,
                    marginBottom: 2,
                    flexDirection: "row",
                    width: "101%",
                    padding: 5,
                  }}
                >
                  {/* User Summary Work Chart Start */}
                  <div
                    style={{
                      width: "49%",
                      background: "white",
                      // padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Sales & Manpower Table 2 starts */}
                    <div
                      style={{
                        marginBottom: -2,
                        background: "white",
                        borderRadius: 8,
                        border: "0 #E6E6E6 solid",
                      }}
                    >
                      <div
                        className="card-header"
                        style={{
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          padding: "10px 15px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                            }}
                          >
                            User Work Summary
                          </div>
                          <div
                            className="Frame427319174"
                            style={{
                              fontSize: 14,
                              color: "#004969",
                            }}
                          >
                            {dayjs(selectedDate).format("DD-MM-YYYY") ==
                              dayjs().format("DD-MM-YYYY")
                              ? "Todays"
                              : dayjs(selectedDate).format("DD-MM-YYYY")}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: 10,
                            marginTop: 2,
                            color: "#666",
                          }}
                        >
                          (Considering 1st Work Done)
                        </div>
                      </div>
                    </div>

                    {Object.keys(managerDashboardData?.dashboardApi).length !==
                      0 &&
                      managerDashboardData?.dashboardApi?.dtoOtherTaskWithCounts
                        .length !== 0 ? (
                      <>
                        <MonthlyBarChart
                          // radioValue={onChangeRadioValue}
                          height={400}
                          series={[
                            {
                              data: managerDashboardData.dashboardApi.dtoOtherTaskWithCounts.map(
                                (dataObj) =>
                                  dataObj.count !== null ? dataObj.count : 0
                              ),
                            },
                          ]}
                          optionsObj={{
                            chart: {
                              type: "bar",
                              height: 365,
                              events: {
                                dataPointSelection: (
                                  event,
                                  chartContext,
                                  config
                                ) => {
                                  const otherTaskId =
                                    managerDashboardData.dashboardApi
                                      .dtoOtherTaskWithCounts[
                                      config.dataPointIndex
                                    ]?.id;
                                  this.onclickUserWorkSummary(otherTaskId);
                                },
                              },
                            },

                            plotOptions: {
                              bar: {
                                columnWidth: "30%",
                                distributed: true,
                              },
                            },
                            stroke: {
                              show: true,
                              width: 2,
                              // colors: ["transparent"],
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            xaxis: {
                              categories:
                                managerDashboardData.dashboardApi.dtoOtherTaskWithCounts.map(
                                  (dataObj) =>
                                    dataObj.name !== null ? dataObj.name : ""
                                ),
                            },
                            // yaxis: {
                            //   title: {
                            //     text: "$ (thousands)",
                            //   },
                            // },
                            fill: {
                              opacity: 1,
                            },
                            colors: [
                              "#FD9600",
                              "#00FFFF",
                              "#008000",
                              "#DE00FD",
                              "#FF0000",
                              "#000FFF",
                              "#61EE9B",
                            ],

                            tooltip: {
                              theme: "light",
                            },
                          }}
                        />
                      </>
                    ) : null}
                  </div>

                  {/* User Summary Work Chart end */}

                  {/* Time Slot Wise start */}

                  <div
                    style={{
                      width: "49%",
                      background: "white",
                      padding: 10,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="Frame427319166"
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        // gap: 10,
                        display: "inline-flex",
                        marginBottom: 25,
                      }}
                    >
                      <div
                        className="Frame427319174"
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          // alignItems: "left",
                          fontSize: 14,
                          display: "flex",
                        }}
                      >
                        Time Slot Wise Working
                      </div>

                      <div
                        className="Frame427319174"
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "right",
                          fontSize: 14,
                          color: "#004969",
                          display: "flex",
                        }}
                      >
                        {dayjs(selectedDate).format("DD-MM-YYYY") ==
                          dayjs().format("DD-MM-YYYY")
                          ? "Todays"
                          : dayjs(selectedDate).format("DD-MM-YYYY")}
                      </div>
                    </div>

                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi.timeSlots &&
                      managerDashboardData.dashboardApi.timeSlots.map(
                        (obj, index) => {
                          return (
                            <>
                              <div
                                className="Frame427319166"
                                style={{
                                  width: "100%",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  color: "#004969",
                                  gap: 10,
                                  fontSize: 18,
                                  fontWeight: 450,
                                  display: "inline-flex",
                                  marginBottom: 5,
                                }}
                                onClick={() => this.timeSlotsMethod(obj.id)}
                              >
                                {obj.fromTime + " To " + obj.toTime}
                              </div>

                              <div
                                className="Frame427319166"
                                style={{
                                  width: "100%",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  display: "inline-flex",
                                  marginBottom: 15,
                                  overflowX: "auto",
                                  whiteSpace: "nowrap",
                                  scrollbarWidth: "thin",
                                  paddingBottom: 10,
                                }}
                              >
                                {obj.dtoTimeSlotAndOtherTasks.map((dataObj) => {
                                  return (
                                    <div
                                      key={dataObj.otherTaskName}
                                      className="Frame427319166"
                                      style={{
                                        justifyContent: "space-between",
                                        width: "25%",
                                        fontSize: 14,
                                        flexShrink: 0,
                                      }}
                                    >
                                      {dataObj.otherTaskName +
                                        ": " +
                                        dataObj.count}
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          );
                        }
                      )}
                  </div>
                  {/* Time Slot Wise end */}
                </div>

                <div
                  className="row"
                  style={{
                    gap: 10,
                    marginBottom: 10,
                    padding: 5,
                    flexDirection: "row",
                    width: "102%",
                  }}
                >
                  {/* Category wise chart start */}
                  <div
                    style={{
                      width: "48.5%",
                      background: "white",
                      padding: 10,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    <Grid item xs={12} md={4} lg={4} background="yellow">
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="h5">
                            Category-wise Summary
                          </Typography>
                        </Grid>

                        <div
                          className="Frame427319174"
                          style={{
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "right",
                            fontSize: 16,
                            color: "#004969",
                            display: "flex",
                          }}
                        >
                          MTD
                        </div>
                      </Grid>

                      <Box
                        sx={{ pt: 10, pr: 2, width: "750px", height: "600px" }}
                      >
                        {managerDashboardData &&
                          Object.keys(managerDashboardData).length != 0 &&
                          managerDashboardData.dashboardApi &&
                          managerDashboardData.dashboardApi
                            .dtoCategoryWiseTotalAmounts &&
                          managerDashboardData.dashboardApi
                            .dtoCategoryWiseTotalAmounts.length != 0 ? (
                          <DonutChart
                            series={managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts.map(
                              (category) => {
                                return category.totalAmt != null
                                  ? category.totalAmt
                                  : "";
                              }
                            )}
                            width={"600"}
                            options={{
                              chart: {
                                height: "300%",
                                width: "500%",
                                type: "donut",
                                events: {
                                  dataPointSelection: (
                                    event,
                                    chartContext,
                                    config
                                  ) => {
                                    const categoryId =
                                      managerDashboardData?.dashboardApi
                                        ?.dtoCategoryWiseTotalAmounts[
                                        config.dataPointIndex
                                      ]?.category?.id;
                                    if (categoryId) {
                                      this.onClickCatgoryWiseSummary(
                                        categoryId
                                      );
                                    }
                                  },
                                },
                              },
                              animations: {
                                enabled: true,
                                easing: "easeinout",
                                speed: 1000,
                                animateGradually: {
                                  enabled: true,
                                  delay: 150,
                                },
                                dynamicAnimation: {
                                  enabled: true,
                                  speed: 100,
                                },
                              },
                              labels:
                                managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts.map(
                                  (category) => {
                                    return category.category.name != null
                                      ? category.category.name
                                      : "";
                                  }
                                ),
                              responsive: [
                                {
                                  breakpoint: 480,
                                  options: {
                                    chart: {
                                      width: 600,
                                    },
                                    legend: {
                                      position: "bottom",
                                    },
                                  },
                                },
                              ],
                            }}
                          />
                        ) : (
                          <NoDataFound />
                        )}
                      </Box>
                    </Grid>
                  </div>

                  {/* Team Coverage Table Start */}
                  <div
                    style={{
                      width: "48.5%",
                      background: "white",
                      padding: 10,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    <Grid item xs={12} md={4} lg={4} background="yellow">
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="h5">Team Coverage</Typography>
                        </Grid>

                        <div
                          className="Frame427319174"
                          style={{
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "right",
                            fontSize: 16,
                            color: "#004969",
                            display: "flex",
                          }}
                        >
                          MTD
                        </div>
                      </Grid>
                    </Grid>
                    <br />

                    <DynamicTable
                      data={loginPersonDataList}
                      tableHead={[
                        {
                          name: "index",
                          title: "Sr.No",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                          canSearch: true,
                        },
                        {
                          name: "loginPersonName",
                          title: "Name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                          linkFlag: true,
                        },
                        {
                          name: "achievedAmount",
                          title: "Achieved Amount",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                      ]}
                      showPegination={false}
                      isActionColActive={false}
                      rowLink={this.rowLinkForTeamCoverage}
                      showSearchBoxForTable={false}
                    />
                  </div>
                </div>

                {onClickTeamCoverageSelfFlag && (
                  <>
                    <TeamCoverageSelfPopUp
                      open={onClickTeamCoverageSelfFlag}
                      columns={[
                        {
                          name: "index",
                          title: "Sr.No",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                          canSearch: true,
                        },
                        {
                          name: "salesTeamName",
                          title: "Name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                          linkFlag: true,
                        },
                        {
                          name: "address",
                          title: "Address",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                        },
                        {
                          name: "distributorsCount",
                          title: "Distriutor",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "beatCount",
                          title: "Beats",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "outletCount",
                          title: "Outlets",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "totalAmt",
                          title: "Value",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "unvisited",
                          title: "TC/Unvisited",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "pcCount",
                          title: "PC",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                      ]}
                      handleCloses={this.handleCloseForTeamCoverage}
                      rows={teamCoverageFirstList}
                      rowLink={this.rowLinkTeamCoverageForSalesTeam}
                    />
                  </>
                )}

                {onClickTeamCoverageSalesTeamFlag && (
                  <>
                    <TeamCoverageForSalesTeamPopUp
                      open={onClickTeamCoverageSalesTeamFlag}
                      columns={[
                        {
                          name: "index",
                          title: "Sr.No",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                          canSearch: true,
                        },
                        {
                          name: "salesTeamName",
                          title: "Name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                          linkFlag: true,
                        },
                        {
                          name: "address",
                          title: "Address",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                        },
                        {
                          name: "distributorsCount",
                          title: "Distriutor",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "beatCount",
                          title: "Beats",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "outletCount",
                          title: "Outlets",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "totalAmt",
                          title: "Value",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "unvisited",
                          title: "TC/Unvisited",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                        {
                          name: "pcCount",
                          title: "PC",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "right",
                          canSearch: true,
                        },
                      ]}
                      handleCloses={this.handleCloseForTeamCoverageSalesTeam}
                      rows={teamCoverageSalesTeamList}
                      rowLink={this.rowLinkTeamCoverageForSalesTeamOrBeat}
                    />
                  </>
                )}

                {onClickTeamCoverageBeatFlag && (
                  <TeamCoverageForBeatPopUp
                    open={onClickTeamCoverageBeatFlag}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "beatName",
                        title: "Beat",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                        linkFlag: true,
                      },
                      {
                        name: "outletCount",
                        title: "Outlet",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "unvisited",
                        title: "TC/Unvisited",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "productiveCount",
                        title: "PC",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "totalAmt",
                        title: "Value",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "totalQty",
                        title: "Qty",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "newAddedOutletCount",
                        title: "New Outlet",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloseForTeamCoverageBeat}
                    rows={teamCoverageBeatList}
                    rowLink={this.rowLinkTeamCoverageForOutlet}
                  />
                )}

                {onClickTeamCoverageOutletFlag && (
                  <TeamCoverageForOutletPopUp
                    open={onClickTeamCoverageBeatFlag}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "firmName",
                        title: "Outlet",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                        linkFlag: true,
                      },
                      {
                        name: "lastVisitTime",
                        title: "Last Visit",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "lastOrderTime",
                        title: "Last Order",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "totalQty",
                        title: "Qty",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "totalAmt",
                        title: "Value",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "visitCount",
                        title: "Visit Count",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "productiveCount",
                        title: "Total Pc",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloseForTeamCoverageOutlet}
                    rows={teamCoverageForOutletList}
                    rowLink={this.rowLinkTeamCoverageForTimeLine}
                  />
                )}

                {onClickTeamCoverageTimelineFlag && (
                  <TeamCoverageForTimeLinePopUp
                    open={onClickTeamCoverageTimelineFlag}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "date",
                        title: "Date",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "salesPersonName",
                        title: "Sales Team Name",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                        linkFlag: true,
                      },
                      {
                        name: "totalAmt",
                        title: "Value",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                      {
                        name: "totalQty",
                        title: "Qty",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloseForTeamCoverageTimeline}
                    rows={teamCoverageForTimline}
                    rowLink={this.rowLinkTeamCoverageForProduct}
                  />
                )}

                {onClickTeamCoverageProductFlag && (
                  <TeamCoverageForProductPopUp
                    open={onClickTeamCoverageProductFlag}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "name",
                        title: "Product Name",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                      },
                      {
                        name: "totalQty",
                        title: "Qty",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloseForTeamCoverageProduct}
                    rows={teamCoverageForProduct}
                  />
                )}

                {onClickTagetFlag && (
                  <TargetPopUpRMDashboard
                    open={onClickTagetFlag}
                    selectedDate={selectedDate}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "selectedDate",
                        title: "Date",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "day",
                        title: "Day",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                      },
                      {
                        name: "AchievedTarget",
                        title: "Achieved Target",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "right",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloses}
                    rows={targetAchievementList}
                  />
                )}

                {onClickUserSummaryFlag && (
                  <UserSummaryPopUpRMDashboard
                    open={onClickUserSummaryFlag}
                    selectedDate={selectedDate}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "name",
                        title: "Name",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                        linkFlag: true,
                      },
                      {
                        name: "address",
                        title: "Address",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                      },
                      {
                        name: "flag",
                        title: "Status",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "checkInTime",
                        title: "Check In Time",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "checkOutTime",
                        title: "Check Out Time",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "otherTaskName",
                        title: "Task",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                      },

                      {
                        name: "workingHrs",
                        title: "Working Hours",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                    ]}
                    handleCloses={this.handleCloses}
                    rows={userSummaryList}
                    rowLink={this.rowLink}
                  />
                )}

                {onClickUserWorkSummaryFlag && (
                  <UserWorkSummaryPopUpRMDashboard
                    open={onClickUserWorkSummaryFlag}
                    otherTaskId={otherTaskId}
                    DataToSetUserWorkSummary={DataToSetUserWorkSummary}
                    selectedDate={selectedDate}
                    columns={
                      otherTaskId == 1
                        ? [
                          {
                            name: "index",
                            title: "Sr.No",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "name",
                            title: "Name",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                            linkFlag: true,
                          },
                          {
                            name: "areaNames",
                            title: "Area",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "firstCall",
                            title: "First Call",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "firstPc",
                            title: "First PC",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "scCount",
                            title: "SC",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "tcCount",
                            title: "TC",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },

                          {
                            name: "pcCount",
                            title: "PC",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "zocCount",
                            title: "ZOC",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "target",
                            title: "Target",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "netAmt",
                            title: "Net Amt",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "avgAmt",
                            title: "Avg Amt(MTD)",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "qty",
                            title: "Qty",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "lpsiPer",
                            title: "LPSI(%)",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "productivityPer",
                            title: "Productivity(%)",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                        ]
                        : [
                          {
                            name: "index",
                            title: "Sr.No",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "name",
                            title: "Name",
                            width: "20%",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                            linkFlag: true,
                          },
                          {
                            name: "areaNames",
                            title: "Area",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "checkInTime",
                            title: "Check In Time",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "checkOutTime",
                            title: "Check Out Time",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },

                          {
                            name: "workingHrs",
                            title: "Working Hours",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                        ]
                    }
                    handleCloses={this.handleCloses}
                    rows={userWorkSummaryList}
                    rowLink={this.rowLink}
                  />
                )}

                {onClickCatSummaryFlag && (
                  <CategoryWiseSummaryPopUpRMDashboard
                    open={onClickCatSummaryFlag}
                    DataToSetForCat={DataToSetForCat}
                    catWiseSummaryType={catWiseSummaryType}
                    columns={
                      catWiseSummaryType == 0
                        ? [
                          {
                            name: "index",
                            title: "Sr.No",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "productName",
                            title: "Product Name",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "totalQty",
                            title: "Qty",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "totalAmt",
                            title: "Total Amt",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                        ]
                        : [
                          {
                            name: "index",
                            title: "Sr.No",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "packagingTypeName",
                            title: "Packaging Type Name",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "totalQty",
                            title: "Qty",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "totalAmt",
                            title: "Total Amt",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                        ]
                    }
                    handleCloses={this.handleCloses}
                    changeRadioHandler={this.changeRadioHandler}
                    rows={
                      catWiseSummaryType == 0
                        ? byProductWiseCatSummary
                        : packagingTypeList
                    }
                  />
                )}

                {onClickTimeSlotFlag && (
                  <TimeSlotPopUpRMDashboard
                    open={onClickTimeSlotFlag}
                    selectedDate={selectedDate}
                    rows={filterTimeSLotList[0].dtoTimeSlotAndOtherTasks}
                    timeSlotList={filterTimeSLotList}
                    handleCloses={this.handleCloses}
                    columns={[
                      {
                        name: "index",
                        title: "Sr.No",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                      {
                        name: "otherTaskName",
                        title: "Task Name",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "left",
                        canSearch: true,
                        linkFlag: true,
                      },
                      {
                        name: "count",
                        title: "Count",
                        positionCenter: false,
                        showInscreen: true,
                        alignCenter: "center",
                        canSearch: true,
                      },
                    ]}
                    rowLink={this.rowLinkForTimeSlot}
                  />
                )}

                {onClickTimeSlotTaskFlag && (
                  <TimeSlotOtherTaskPopUpRMDashboard
                    open={onClickTimeSlotTaskFlag}
                    selectedDate={selectedDate}
                    taskName={taskName}
                    rows={timeSlotTaskList}
                    handleCloses={this.handleClosesForTimeSlot}
                    columns={
                      otherTaskIdForTimeSlot == 1
                        ? [
                          {
                            name: "index",
                            title: "Sr.No",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "date",
                            title: "Date",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "salesTeamPersonName",
                            title: "Name",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "salesTeamPersonAddress",
                            title: "Address",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "fromTime",
                            title: "Order Time",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            name: "entityName",
                            title: "Outlet Name",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                          {
                            name: "amount",
                            title: "Amount",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "right",
                            canSearch: true,
                          },
                          {
                            name: "extra1",
                            title: "Product Count",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                        ]
                        : otherTaskIdForTimeSlot == 2
                          ? [
                            {
                              name: "index",
                              title: "Sr.No",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "center",
                              canSearch: true,
                            },
                            {
                              name: "date",
                              title: "Date",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "center",
                              canSearch: true,
                            },
                            {
                              name: "salesTeamPersonName",
                              title: "Name",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "left",
                              canSearch: true,
                            },
                            {
                              name: "salesTeamPersonAddress",
                              title: "Address",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "left",
                              canSearch: true,
                            },
                            {
                              name: "entityName",
                              title: "Distributor Name",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "left",
                              canSearch: true,
                            },
                            {
                              name: "amount",
                              title: "Amount",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "right",
                              canSearch: true,
                            },
                            {
                              name: "extra1",
                              title: "Product Count",
                              positionCenter: false,
                              showInscreen: true,
                              alignCenter: "center",
                              canSearch: true,
                            },
                          ]
                          : []
                    }
                    otherTaskIdForTimeSlot={otherTaskIdForTimeSlot}
                  />
                )}
              </div>

              <div
                className="row"
                style={{
                  gap: 8,
                  marginBottom: 10,
                  width: "100%",
                  marginLeft: 5,
                }}
              >
                <div
                  style={{
                    width: "97%",
                    background: "white",
                    padding: 5,
                    borderRadius: 8,
                    border: "1px #E6E6E6 solid",
                  }}
                >
                  {/* Top beat starts */}
                  {/* 8 may changes  */}
                  <div
                    // className="card"
                    style={{
                      marginBottom: -2,
                      background: "white",
                      borderRadius: 8,
                      border: "0 #E6E6E6 solid",
                    }}
                  >
                    <div
                      className="card-header align-items-center d-flex"
                      style={{
                        background: "white",
                        borderRadius: 8,
                        border: "0 #E6E6E6 solid",
                        // marginTop: 20,
                      }}
                    >
                      <h4
                        className="text-uppercase card-title mb-0 flex-grow-1"
                        style={{}}
                      >
                        Sales Team List
                        <div
                          style={{
                            marginLeft: -20,
                          }}
                        >
                          <LandingScreenHeader
                            screenTitle={""}
                            showSearchBox={true}
                            showTable={true}
                            showFilter={false}
                            showPdfDownload={false}
                            showExcelDownload={false}
                            generateExcel={this.generateExcel}
                            onSearch={this.onSearchForSalesTeamList}
                          />
                        </div>
                      </h4>
                      <h4
                        className="text-uppercase card-title mb-0 flex-grow-1"
                        style={{
                          textAlign: "center",
                          width: "300px",
                        }}
                      >
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={12}
                          lg={12}
                          container
                          justifyContent="end"
                          flexWrap={"wrap"}
                        >
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={8}
                            lg={8}
                            container
                            justifyContent="space-evenly"
                          >
                            <Grid
                              item
                              xs={12}
                              md={2}
                              sm={12}
                              flexDirection={"row"}
                              display={"flex"}
                            >
                              <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16, color: redColor }}
                                label="* "
                              />
                              <LabelCompo
                                className="text-black"
                                style={{
                                  fontSize: 16,
                                  color: titleColor,
                                  marginTop: "5px",
                                  marginRight: "8px",
                                }}
                                label="Date :"
                              />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                              <BasicDatePicker
                                color="primary"
                                name="dateForSalesTeamList"
                                size="small"
                                value={dateForSalesTeamList}
                                disabled={false}
                                fullWidth
                                onChange={this.changeDateNew(
                                  "dateForSalesTeamList"
                                )}
                                errorText={
                                  formErrors["dateForSalesTeamListError"]
                                    ? formErrors["dateForSalesTeamListError"]
                                    : ""
                                }
                                isError={
                                  formErrors["dateForSalesTeamListError"]
                                    ? formErrors["dateForSalesTeamListError"]
                                    : ""
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            sm={12}
                            xs={12}
                            md={4}
                            lg={4}
                            gap={2}
                            container
                            display={"flex"}
                            flexDirection="row"
                            justifyContent="end"
                            alignItems="center"
                          >
                            <ButtonCompo
                              sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                                height: "40px",
                                width: "100px",
                                lineHeight: "1.5",
                              }}
                              size="medium"
                              type="button"
                              variant="contained"
                              name={"Search"}
                              onClick={this.searchSalesTeamData}
                            />

                            <ButtonCompo
                              sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                                height: "40px",
                                width: "100px",
                                lineHeight: "1.5",
                              }}
                              size="medium"
                              type="button"
                              variant="contained"
                              name={"Excel"}
                              onClick={this.generateExcel}
                            />
                          </Grid>
                        </Grid>
                      </h4>
                    </div>
                  </div>

                  <Tabs
                    value={value}
                    onChange={this.handleChangeTabValue}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                    sx={{
                      "& .MuiTab-root": { marginRight: "15px" },
                    }}
                  >
                    <Tab
                      value="0"
                      label={
                        "All" + " ( " + dashboardData2?.salesInfo.length + " ) "
                      }
                    />
                    <Tab
                      value="1"
                      label={
                        "Present" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.attendenceStatus == 1
                        ).length +
                        " ) "
                      }
                    />
                    <Tab
                      value="2"
                      label={
                        "Absent" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.isAbsent == 1
                        ).length +
                        " ) "
                      }
                    />
                    <Tab
                      value="3"
                      label={
                        "Late" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.checkInStatus == 1
                        ).length +
                        " ) "
                      }
                    />
                    <Tab
                      value="4"
                      label={
                        "On Leave" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.isLeave == 1
                        ).length +
                        " ) "
                      }
                    />
                  </Tabs>

                  <br />

                  <TableContainer
                    sx={{
                      maxHeight: 440,
                      // width: 610,
                      // padding: 1.5,
                      // marginTop: 2.5,
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <TableRow>
                          <TableCell
                            color="#000"
                            align="center"
                            sx={{ width: "1%", color: "#000" }}
                            canSearch="true"
                          >
                            Sr.No
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "5%", color: "#000" }}
                            canSearch="true"
                          >
                            Sales Team Name
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "5%", color: "#000" }}
                            canSearch="true"
                          >
                            Employee Code
                          </TableCell>

                          {localStorage.getItem(
                            "showAreaDistrictColumnsOnSalesTeamListDashboard"
                          ) &&
                            localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 && (
                              <>
                                <TableCell
                                  align="center"
                                  sx={{ width: "2%", color: "#000" }}
                                  canSearch="true"
                                >
                                  District
                                </TableCell>

                                <TableCell
                                  align="center"
                                  sx={{ width: "15%", color: "#000" }}
                                  canSearch="true"
                                >
                                  Area
                                </TableCell>
                              </>
                            )}

                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Beat Count
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Outlet
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Productive Call
                          </TableCell>

                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Unvisited Outlet
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Zero Order
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Order Amount
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Sales Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dashboardData2.salesInfo.length != 0 &&
                          this.getFilteredTableDataForSalesTeamList(
                            value == 0
                              ? dashboardData2?.salesInfo
                              : value == 1
                                ? dashboardData2?.salesInfo.filter(
                                  (row) => row.attendenceStatus == 1
                                )
                                : value == 2
                                  ? dashboardData2?.salesInfo.filter(
                                    (row) => row.isAbsent == 1
                                  )
                                  : value == 3
                                    ? dashboardData2?.salesInfo.filter(
                                      (row) => row.checkInStatus == 1
                                    )
                                    : dashboardData2?.salesInfo.filter(
                                      (row) => row.isLeave == 1
                                    )
                          )?.map((salesTeamObject, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  canSearch="true"
                                  width="5%"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell width="15%" canSearch="true">
                                  <Link
                                    color={cyanBlue}
                                    component={RouterLink}
                                    to={
                                      localStorage.getItem(
                                        "showRealTimeTracking"
                                      ) &&
                                        localStorage.getItem(
                                          "showRealTimeTracking"
                                        ) == 1
                                        ? "/gmap-with-functionality/" +
                                        salesTeamObject.salesTeamId +
                                        "/" +
                                        salesTeamObject.userTypeId
                                        : "/sales/" +
                                        salesTeamObject.salesTeamId +
                                        "/" +
                                        salesTeamObject.userTypeId
                                    }
                                  >
                                    {salesTeamObject.name +
                                      " (" +
                                      salesTeamObject.stockStakeHolderTypePrefix +
                                      ")"}
                                  </Link>
                                </TableCell>
                                <TableCell align="center" canSearch="true">
                                  {salesTeamObject?.employeeCode || "-"}
                                </TableCell>
                                {localStorage.getItem(
                                  "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                ) &&
                                  localStorage.getItem(
                                    "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                  ) == 1 && (
                                    <>
                                      <TableCell align="left" canSearch="true">
                                        {salesTeamObject.district_names}
                                      </TableCell>

                                      <TableCell align="left" canSearch="true">
                                        {salesTeamObject.area_names}
                                      </TableCell>
                                    </>
                                  )}
                                <TableCell
                                  width="2%"
                                  align="right"
                                  canSearch="true"
                                >
                                  <div
                                    onClick={(e) =>
                                      this.salesTeamHandler(
                                        e,
                                        salesTeamObject.salesTeamId
                                      )
                                    }
                                    style={{
                                      color: cyanBlue,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {salesTeamObject.beatCount}
                                  </div>
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.totalOutletCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.productiveCall}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.unvisitedOutletCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.zeroOrderCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {(+salesTeamObject.totalAmount).toFixed(2)}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {(+salesTeamObject.totalSalesAmt).toFixed(2)}
                                </TableCell>
                              </TableRow>
                            );
                          })}

                        <TableRow>
                          {localStorage.getItem(
                            "showAreaDistrictColumnsOnSalesTeamListDashboard"
                          ) &&
                            localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 ? (
                            <TableCell align="right" width="2%" colSpan={5}>
                              Total
                            </TableCell>
                          ) : (
                            <TableCell align="right" width="2%" colSpan={4}>
                              Total
                            </TableCell>
                          )}
                          <TableCell TableCell align="right">
                            {totalOutletCount}
                          </TableCell>
                          <TableCell align="right">{productiveCall}</TableCell>
                          <TableCell align="right">{unvisited}</TableCell>
                          <TableCell align="right">{zero}</TableCell>
                          <TableCell align="right">
                            {(+totalAmount).toFixed(2)}
                          </TableCell>
                          <TableCell align="right">
                            {(+salesAmt).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {beatPopupFlag && (
                    <BeatPopUp
                      open={beatPopupFlag}
                      handleCloses={this.handleClosesSalesTeam}
                      columns={[
                        {
                          title: "Sr. No.",
                          name: "index",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                          canSearch: true,
                        },
                        {
                          title: "Beat",
                          name: "beatName",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                        },
                      ]}
                      rows={beatList?.beatFromSalesTeamId}
                    />
                  )}
                </div>
              </div>

              <footer className="footer">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6">2022 © Byte Elephants. </div>
                    <div className="col-sm-6">
                      <div className="text-sm-end d-none d-sm-block">
                        {" "}
                        Designed &amp; Developed by Byte Elephants Technologies
                        PVT LTD{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  managerDashboardData: state.managerDashboard,
  dashboardData2: state.adminDashboard,
  beatList: state.beat,
});

const mapDispatchToProps = {
  onToggle,
  showLoador,
  showNotification,
  getManagerDashboardApi,
  getSalesTeamInfoByDatesWithAttendance,
  getBeatFromSalesTeamId,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(RMDashboard);
